import { render, staticRenderFns } from "./ChatFloatingButton.vue?vue&type=template&id=5fd588d0&scoped=true&"
import script from "./ChatFloatingButton.vue?vue&type=script&lang=ts&"
export * from "./ChatFloatingButton.vue?vue&type=script&lang=ts&"
import style0 from "./ChatFloatingButton.vue?vue&type=style&index=0&id=5fd588d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd588d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBadge,VBtn,VIcon,VSlideYReverseTransition})
